// src/utils/validators.ts
// Small shared checks reused by each form's own `validate()` function —
// intentionally not a schema library since most forms here are plain
// useState + a hand-rolled errors map, not react-hook-form.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MOBILE_RE = /^[6-9]\d{9}$/;

export function isValidEmail(v: string): boolean {
  return EMAIL_RE.test(v.trim());
}

export function isValidMobile(v: string): boolean {
  return MOBILE_RE.test(v.trim());
}

// Bounds for plain <input type="date"> fields — the year segment has no
// built-in cap (Chrome lets it spin all the way to 275760, the JS Date max),
// so every date picker in the app needs both the min/max HTML attributes
// AND this check before save, since typed-out-of-range values still fire
// onChange with a well-formed but absurd "YYYY-MM-DD" string.
export const MIN_DATE_STR = '1900-01-01';
export const MAX_DATE_STR = '2100-12-31';

export function isReasonableDate(v: string): boolean {
  if (!v) return true;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
  return v >= MIN_DATE_STR && v <= MAX_DATE_STR;
}
